<div *ngIf="sharedService.redirectTo == 'preview'">
    <div class="publiish-bar" *ngIf="sharedService.setup.publishedModifiedDate != sharedService.setup.dateModified"
        [ngStyle]="{
        background : sharedService.selectedTheme.config.accent,
        color : sharedService.selectedTheme.config.background
    }">
        <span>You have some unpublished changes.</span>
        <ccl-basic-button (clickEvent)='publishCatalog()' buttonStyle='c-btn--short'>
            <span>Publish now</span>
        </ccl-basic-button>
        <a href="javascript:void(0)" (click)="launchPublishedCatalog()" class="ccl__external_link"
            *ngIf="sharedService.setup.isPublished">
            <span>Launch catalog</span>
            <i class="fa fa-lg fa-external-link"></i>
        </a>
    </div>
    <div class="publiish-bar" *ngIf="sharedService.setup.publishedModifiedDate == sharedService.setup.dateModified"
        [ngStyle]="{
        background : sharedService.selectedTheme.config.accent,
        color : sharedService.selectedTheme.config.background
    }">
        <span>Nothing to publish.</span>
        <a href="javascript:void(0)" (click)="launchPublishedCatalog()" class="ccl__external_link">
            <span>Launch catalog</span>
            <i class="fa fa-lg fa-external-link"></i>
        </a>
    </div>
    <div class="preview-sticky-note" [ngStyle]="{
        background : sharedService.selectedTheme.config.accent,
        color : sharedService.selectedTheme.config.background
    }">
        <strong>Preview</strong>
    </div>
</div>
<router-outlet>

</router-outlet>